class BrowserUtil {
  isSafari() {
    const isChromeUserAgent = navigator.userAgent.indexOf('Chrome') > -1;
    const isSafariUserAgent = navigator.userAgent.indexOf('Safari') > -1;
    if (isSafariUserAgent) {
      return !isChromeUserAgent;
    }
    return false;
  }

  /**
   * Gets the site URL based on the specified site type
   * @param {string} site - The site type ('portal', 'group_home_admin', 'presence', 'notice_boards')
   * @returns {string} The complete site URL
   */
  getSiteUrl(site = 'portal') {
    const isLocally = process.env.NODE_ENV === 'development';
    const protocol = location.protocol;
    const host = location.host; // Includes port
    let path = '/administration';

    if (site === 'portal') {
      if (isLocally) {
        path = '';
      } else {
        path = '/portal';
      }
    } else if (site === 'group_home_admin') {
      path = '/group_home_admin';
    } else if (site === 'presence') {
      path = '/presence';
    } else if (site === 'notice_boards') {
      path = '/infotavle';
      if (isLocally) {
        path = '/notice_boards';
      }
    }

    if (isLocally) {
      path += '/index.html';
    }

    return `${protocol}//${host}${path}`;
  }
}

export const browserUtil = new BrowserUtil();
